import React from 'react';
import { Redirect } from "react-router-dom";

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SingleNextButton from '../Atoms/SingleNextButton';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import StepShell from '../StepComponents/StepShell';
import Form from '../StepComponents/Form';
import { getApp, setApp, addAuthorizedUserObject, editAuthorizedUserObject, deleteAuthorizedUserObject, resetAuthorizedUserObject } from '../../index';
import { nameRegex, dateRegex, ssnRegex } from '../../Utils/ValidationPatterns';

export class StepAuthorizedUser extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            authorizedUser: ''
        };
    }
    
    componentDidMount() {

        var existingAuthorizedUserValue = getApp('authorizedUser');

        if (existingAuthorizedUserValue !== "") {

            this.setState({ authorizedUser: existingAuthorizedUserValue });

            var aSRadioId;

            if (existingAuthorizedUserValue === "yes") {
                aSRadioId = "authorizedUserYes";
            }
            if (existingAuthorizedUserValue === "no") {
                aSRadioId = "authorizedUserNo";
            }

            document.getElementById(aSRadioId).checked = true;
        }

        resetASInfo();
    }

    checkAuthorizedUser(event) {
        var newState = event.target.value;
        this.setState({ authorizedUser: newState });
        setApp('authorizedUser', newState);
        if (newState === 'no') {
            resetASInfo();
            resetAuthorizedUserObject();
            setApp('blockAuDisclosure', false);
            this.props.history.push('/loan-application/balance-transfer');
        } else {
            setApp('blockAuDisclosure', true);
        }
    }

    render() {

        let curCoApp = getApp('coApp');
        let NextButton;
        let nextLink = '/loan-application/authorized-user-info';
        let asCount = getApp('authorizedUserArray').length;
        let au = this.state.authorizedUser;

        if (curCoApp === "true") {
            var back_link = '/loan-application/co-applicant-work';
        } else {
            var back_link = '/loan-application/co-applicant';
        }

        if (asCount > 0 && au === 'yes') {
            nextLink = '/loan-application/authorized-user-detail';
        } 
        if (asCount === 0 && au === 'no') {
            let style = {
                "marginTop": "20px",
                "textAlign": "Center"
            };
            NextButton = (
                <div className="loanApp-form-row">
                    <div className="col col-12" style={style}>
                        <p>No authorized user was added to this application.</p>
                    </div>
                    <SingleNextButton nextBtnTxt="Next" />
                </div>
            );
            nextLink = '/loan-application/balance-transfer';
        }

        return (
            <StepShell stepID="StepAuthorizedUser"
                friendlyText="Should we send someone else a card?"
                requestText="Would you like to add an authorized user to this account?"
                progress="83%"
                backLink={back_link}
                progressLabel="Authorized User"
            >
                <Form nextLink={nextLink}>
                    <div className="loanApp-radio-buttons hug" onChange={this.checkAuthorizedUser.bind(this)}>
                        <div className="loanApp-form-row">
                            <div className=" col col-6 loanApp-radio">
                                <input type="radio" name="authorizedUser" value="yes" className="pull-left loanApp-form-control" id="authorizedUserYes" />
                                <label htmlFor="aSYes">YES</label>
                                <InvalidFeedback feedback="invalid" />
                            </div>
                            <div className="col col-6 loanApp-radio">
                                <input type="radio" name="authorizedUser" value="no" className="pull-left loanApp-form-control" id="authorizedUserNo" />
                                <label htmlFor="aSNo">NO</label>
                                <InvalidFeedback feedback="invalid" />
                            </div>
                        </div>
                        {NextButton}
                    </div>
                    {this.state.authorizedUser === "yes" ? <AuthorizedUserDisclosure /> : null}
                </Form>
            </StepShell>
        )
    }
}

export class StepAuthorizedUserDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let headTitle = 'You can add up to three authorized users';
        let subTitle = '';
        let asCount = getApp('authorizedUserArray').length;

        if(asCount < 1) {
            subTitle = '';
        }
        else if (asCount >= 1 && asCount < getApp('asMax')) {
            subTitle = 'Would you like to add another user?';
        } else if (asCount === getApp('asMax')) {
            subTitle = '';
        }

        return (
            <StepShell stepID="StepAuthorizedUserDetail"
                friendlyText={headTitle}
                requestText={subTitle}
                progress="83%"
                backLink="/loan-application/authorized-user"
                progressLabel="Authorized User"
            >
                <Form nextLink="/loan-application/balance-transfer">
                    <div className="loanApp-radio-buttons hug">
                        <div className="loanApp-form-row">
                            <AuthorizedUser />
                        </div>
                    </div>
                </Form>
            </StepShell>
        )
    }
}

class AuthorizedUser extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            fireRedirect: false,
            asArray: getApp('authorizedUserArray')
        };
    }

    addAuthorizedUser(event) {
        event.preventDefault();
        var currentASCounter = getApp('asCount');
        setApp('asCount', currentASCounter += 1);
        this.setState({ fireRedirect: true });
        window.scrollTo(0, 0);
    }
    
    render() {

        let asArray = this.state.asArray;
        let asSummary;
        let NextButton;
        let AddButton = (
            <button id="addAuthorizedUser" className="next-btn button" type="submit" onClick={this.addAuthorizedUser.bind(this)}>Add</button>
        );

        if(asArray.length > 0) {
            asSummary = (
                asArray.map((as) => {
                    return (
                        <AuthorizedUserReview 
                            key={as.Id}
                            ASKey={as.Id}
                            FirstName = {as.FirstName}
                            LastName = {as.LastName}
                            DOB = {as.DOB}
                            SSN = {as.SSN}
                        />
                    )
                })
            );
            if(asArray.length >= getApp('asMax')) {
                AddButton = <span></span>
            }
            NextButton = (
                <SingleNextButton nextBtnTxt="Next" />
            );

        } else {
            asSummary = (
                <span></span>
            );

            NextButton = (
                <span></span>
            );
        }

        return (
            <div>
                {asSummary}
                <div className="hug loanApp-btn-wrap single-next">
                    {AddButton}
                    {this.state.fireRedirect && (
                        <Redirect to="authorized-user-info"/>
                    )}
                </div>
                {NextButton}
            </div>
        )
    }
}

class AuthorizedUserReview extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            fireRedirect: false,
        };
    }

    editClick = (e) => {
        e.preventDefault();
        this.setState({ fireRedirect: true });
        window.scrollTo(0, 0);
    }
    
    render() {
        return (
            <div className="step-review">
                <button className="edit-button" onClick={this.editClick} >Edit</button>
                {this.state.fireRedirect && (
                    <Redirect to={{
                        pathname: `/loan-application/authorized-user-info`, 
                        state: {
                            asId: this.props.ASKey
                        }}} />
                )}
                <span>First Name: <strong>{this.props.FirstName}</strong><br /></span>
                <span>Last Name: <strong>{this.props.LastName}</strong><br /></span>
                <span>Date of Birth: <strong>{this.props.DOB}</strong><br /></span>
                <span>Social Security Number: <strong>{this.props.SSN}</strong><br /></span>
            </div>
        )
    }
}

export class StepAuthorizedUserInfo extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            fireRedirect: false
        };
    }
    
    saveAuthorizedUserInfo(e) {
        e.preventDefault();

        if(getApp("auBlockAge") === false){
            this.setState({ fireRedirect: true });
            saveASInfo();
            window.scrollTo(0, 0);
        } else {
            document.querySelector('.asdob-message').classList.add('show');
        }
    }

    deleteAuthorizedUser(e) {
        e.preventDefault();
        this.setState({ fireRedirect: true });
        deleteASInfo();
        window.scrollTo(0, 0);
    }
    
    render() {
        
        let asId;
        let asDeleteButton;
        
        if(this.props.location.state !== undefined){
            asId = this.props.location.state.asId;
            asDeleteButton = (
                <button id="deleteAuthorizedUser" className="next-btn button" onClick={this.deleteAuthorizedUser.bind(this)}>Delete</button>
            )
        }

        return (
            <StepShell stepID="StepAuthorizedUserInfo"
                friendlyText="To whom should we send a card?"
                requestText=""
                progress="83%"
                backLink="/loan-application/authorized-user-detail"
                progressLabel="Authorized User Info"
            >
            <form className="loanApp-form" onSubmit={this.saveAuthorizedUserInfo.bind(this)} >
                <AuthorizedUserInfo asIndex={asId} />
                <div className="hug loanApp-btn-wrap single-next">
                    <button id="addAuthorizedUser" className="next-btn button" type="submit">Save</button>
                    {asDeleteButton}
                    {this.state.fireRedirect && (
                        <Redirect to="/loan-application/authorized-user-detail"/>
                    )}
                </div>
            </form>
            </StepShell>
        )
    }
}

class AuthorizedUserInfo extends React.Component {
    
    componentWillMount() {
        if(this.props.asIndex !== undefined && getApp('authorizedUserArray').length > 0){
            var currentASInfo = getApp('authorizedUserArray').find(as => as.Id === this.props.asIndex);
            setApp('as_fname', currentASInfo.FirstName);
            setApp('as_mname', currentASInfo.MiddleName);
            setApp('as_lname', currentASInfo.LastName);
            setApp('as_dob', currentASInfo.DOB);
            setApp('as_ssn', currentASInfo.SSN);
            setApp('asIndex', this.props.asIndex);
        } else {
            setApp('asIndex', getApp('asCount'));
        }
    }

    render() {
        return (
            <div>
                <TextField name="as_fname" label="First Name" required={true} pattern={nameRegex} />
                <TextField name="as_mname" label="Middle Name" pattern={nameRegex} />
                <TextField name="as_lname" label="Last Name" required={true} pattern={nameRegex} />
                <NumberField name="as_dob" label="Date of Birth (e.g. 09/09/1999)" format="##/##/####" required={true} pattern={dateRegex} />
                <div className="hug">
                    <span className="asdob-message error-message">You need to be 1 or older in order to be an authorized user</span>
                </div>
                <NumberField  name="as_ssn" label="Social Security Number" encName="prim_enc" encrypt={true} format="###-##-####" required={true} pattern={ssnRegex} />
            </div>
        )
    }
}

class AuthorizedUserDisclosure extends React.Component {
    
    constructor(props) {
        super(props);
        var auDisclosure = getApp('asDisclosure'); 
        this.state = {
            checked: auDisclosure
        }
    }

    auDisclosureClicked() {
        this.setState({
            checked: !this.state.checked
        });
        setApp('asDisclosure', !this.state.checked);
        setApp('blockAuDisclosure', this.state.checked)
    }
    
    render() {
        var divStyle = {
            "fontSize": "0.65rem",
            "marginTop": "10px"
        };

        return (
            <div className="loanApp-form-row">
                <div className=" col col-12">
                    <div className="p-sm" style={divStyle}>
                        <p>
                            I agree to add the designated authorized user(s) on my Visa account with Vantage West Credit Union. By submitting this request, the person(s) listed on the next screen will be issued a credit card as an authorized user of my credit card account with Vantage West Credit Union. I acknowledge that the terms and conditions of the Credit Card Agreement will in no way change by adding an authorized user to my Vantage West Credit Union Visa Credit Card.
                        </p>
                        <p>
                            I hereby certify that I will be solely responsible for all usage by my designated authorized user(s) and understand that I am fully responsible, and liable, for ALL purchases made and cash advances received by an authorized user(s) of my credit card account. In addition I am fully responsible for all payments. The credit card and monthly statements will be sent to my address that I have on file with my current VISA credit card.
                        </p>
                        <p>
                            This designation of authorized user(s) shall remain in effect until Vantage West Credit Union receives written notice of the revocation of such designation, signed by Borrower(s), and has had reasonable opportunity to act on such revocation.
                        </p>
                    </div>
                    <div className="loanApp-checkbox hug">
                        <input type="checkbox" name="auth1" value="yes" className="pull-left loanApp-form-control" onChange={this.auDisclosureClicked.bind(this)} defaultChecked={this.state.checked} />
                        <label htmlFor="auth1">I have read and agree to the disclosure listed above</label>
                    </div>
                </div>
                <SingleNextButton nextBtnTxt="Next" />
            </div>
        )
    }
}

function resetASInfo() {
    setApp('asIndex', -1);
    setApp('as_fname', "");
    setApp('as_mname', "");
    setApp('as_lname', "");
    setApp('as_dob', "");
    setApp('as_ssn', "");
}

function saveASInfo() {
    let asIndex = getApp('asIndex');
    let targetASObjectIndex = getApp('authorizedUserArray').findIndex(as => as.Id === asIndex);
    if(targetASObjectIndex === -1) {
        addAuthorizedUserObject();
    } else {
        editAuthorizedUserObject(targetASObjectIndex);
    }
    resetASInfo();
}

function deleteASInfo() {
    let asIndex = getApp('asIndex');
    let targetASObjectIndex = getApp('authorizedUserArray').findIndex(as => as.Id === asIndex);
    deleteAuthorizedUserObject(targetASObjectIndex);
    resetASInfo();
}